import React from 'react';
import styled from 'styled-components';

const Spinner = styled.img`
  position: relative;
  width: 128px;
  height: 128px;
`;

export default Spinner;
